import { ComponentStyleSource, getComponentStyleSource } from '@wix/a11y-adapters';
import { Box, Text, TextButton, Timeline } from '@wix/design-system';
import { Trans } from '@wix/fe-essentials/react';
import { ElementStatus } from '@wix/rules-panel-ui';
import { DuplicateSmall } from '@wix/wix-ui-icons-common';
import React from 'react';
import { generalToolTips } from '../../../../../bi/types';
import { useBiLogger } from '../../../../../hooks/use-bi-logger';
import { useGenericElement } from '../../../../../hooks/use-generic-element';
import { ColorContrastControls } from '../shared/color-contrast-controls';
export const ColorContrastElementGenericTimeline = _ref => {
  let {
    locale,
    minimalRatio,
    elementIndex,
    status,
    failedElement,
    onClickCancel,
    onClickApply,
    showLoader,
    pageId
  } = _ref;
  const {
    handleRescanClick
  } = useGenericElement({
    getComponentStyleSource,
    pageId,
    unknownValue: ComponentStyleSource.UNKNOWN
  });
  const biLogger = useBiLogger();
  const firstStep = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
    size: "tiny"
  }, /*#__PURE__*/React.createElement(Trans, {
    components: {
      boldText: /*#__PURE__*/React.createElement(Text, {
        size: "tiny",
        weight: "bold"
      }),
      copyIcon: /*#__PURE__*/React.createElement(DuplicateSmall, {
        style: {
          verticalAlign: 'text-bottom'
        }
      }),
      noWrap: /*#__PURE__*/React.createElement("span", {
        style: {
          whiteSpace: 'nowrap'
        }
      })
    },
    i18nKey: "accessibility-wizard.rules-list.color-contrast.element.first-item-content.generic",
    values: {
      minimalRatio: new Intl.NumberFormat(locale).format(minimalRatio)
    }
  })), /*#__PURE__*/React.createElement(Box, {
    border: "1px solid",
    borderColor: "D60",
    borderRadius: "6px",
    direction: "vertical",
    gap: "SP2",
    marginTop: "SP1",
    padding: "SP2"
  }, /*#__PURE__*/React.createElement(ColorContrastControls, {
    elementIndex: elementIndex,
    failedElement: failedElement,
    isGeneric: true,
    pageId: pageId,
    showLoader: showLoader,
    status: status,
    onChangeElementsColor: () => {},
    onClickApply: onClickApply,
    onClickCancel: onClickCancel
  })));
  const secondStep = /*#__PURE__*/React.createElement(Text, {
    size: "tiny"
  }, /*#__PURE__*/React.createElement(Trans, {
    components: {
      boldText: /*#__PURE__*/React.createElement(Text, {
        size: "tiny",
        weight: "bold"
      })
    },
    i18nKey: "accessibility-wizard.rules-list.color-contrast.element.second-item-content.generic"
  }));
  const thirdStep = /*#__PURE__*/React.createElement(Text, {
    size: "tiny"
  }, /*#__PURE__*/React.createElement(Trans, {
    components: {
      rescanButton: /*#__PURE__*/React.createElement(TextButton, {
        size: "tiny",
        skin: "dark",
        underline: "always",
        weight: "bold",
        onClick: () => {
          handleRescanClick(failedElement.elementId);
          biLogger.taskElementCtaClick({
            ctaName: generalToolTips.rescanPage,
            index: elementIndex,
            status: status ? ElementStatus.ManualPassed : ElementStatus.ManualFailed
          });
        }
      })
    },
    i18nKey: "accessibility-wizard.rules-list.color-contrast.element.third-item-content.generic"
  }));
  const items = [{
    label: firstStep
  }, {
    label: secondStep
  }, {
    label: thirdStep
  }];
  return /*#__PURE__*/React.createElement(Timeline, {
    gap: "20px",
    items: items,
    skin: "dark"
  });
};
//# sourceMappingURL=color-contrast-element-generic-timeline.js.map